import axiosInstance from "../api/api";

const ContactUsService = {

    contactUs: function (formData) {
        return axiosInstance({
            url: `/api/public/contactUs`,
            method: "POST",
            data: formData,
        });
    },
    subscribePlan: function (formData) {
        return axiosInstance({
            url: `/api/public/subscribePlan`,
            method: "POST",
            data: formData,
        });
    },
    contactUsPartner: function (formData) {
        return axiosInstance({
            url: `/api/public/contactUsPartner`,
            method: "POST",
            data: formData,
        });
    }
};
export default ContactUsService;
